<div
  data-bs-dismiss="offcanvas"
  class="btn btn-success text-black cursor-pointer text-uppercase d-flex align-items-center justify-content-center"
  (click)="switchToGuardian()"
>
  {{ 'back.to.guardian' | translate }}
</div>
